/**
 * TypeScript view of the `cryptogram` format (ADR 0060).
 * Source of truth: `shared/schema/cryptogram.{definition,solution,submission,progress}.json`.
 */

export type Localized = Record<string, string | undefined>;
export type Language = "fr" | "en";

export const LANGUAGES: Language[] = ["fr", "en"];
export const MAX_CIPHERTEXT = 1000;
export const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

/** A public hint: a cipher letter and the plain letter it stands for. */
export interface Given {
  cipher: string;
  plain: string;
}

export interface CryptogramDefinition {
  puzzleType: "cryptogram";
  typeVersion: number;
  language: Language;
  /** A-Z uppercase are enciphered; everything else is shown as it is. */
  ciphertext: string;
  givens?: Given[];
  rulesText?: Localized;
  meta?: Record<string, unknown>;
}

/** The answer key: the plaintext, in the shape of the ciphertext. Hashed on the server. */
export interface CryptogramSolution {
  plaintext: string;
}

/** Cipher letter → plain letter. */
export type Mapping = Record<string, string>;

export interface CryptogramSubmission {
  mapping: Mapping;
}

/** Autosave shape. Opaque to the core; the givens are not stored, they come from the definition. */
export interface CryptogramProgress {
  version: 1;
  mapping: Mapping;
}
